import { SVGProps } from "react"

import { IconProps } from "../nav-icons/icon.types.ts"

export const IconProducts = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <ProductsHover {...props} />
  else return <ProductsDefault {...props} />
}

const ProductsDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="M8 27h16.5c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1ZM11.5 23h1M11.5 16.5h1M11.5 10h1M15.5 23h6M15.5 16.5h6M15.5 10h6"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
      }}
    />
  </svg>
)

const ProductsHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Calque 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="M8 27h16.5c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1Z"
      style={{
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2,
      }}
    />
    <path
      d="M8 27h16.5c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v20c0 .55.45 1 1 1Zm2.5-10.5c0-.55.45-1 1-1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1c-.55 0-1-.45-1-1Zm1-7.5c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1Zm3 14c0-.55.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1Zm1-7.5c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1h-6Zm-1-5.5c0-.55.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1h-6c-.55 0-1-.45-1-1Zm-3 12c-.55 0-1 .45-1 1s.45 1 1 1h1c.55 0 1-.45 1-1s-.45-1-1-1h-1Z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
    />
  </svg>
)
